/**
 * Central CloudWatch RUM defaults. Per-environment values live in environment.rum.
 */
export const RUM_CONFIG = {
  /** Key in the `features` toggles. Absent = off. Separate from the trace flag. */
  featureFlag: 'rum-telemetry',

  /** Fraction of sessions recorded (cost control). */
  defaultSessionSampleRate: 0.1,

  /** Cookies stay off until the user consents. */
  defaultAllowCookies: false,

  /** localStorage key for the consent decision. */
  consentStorageKey: 'odin.telemetry-consent',

  maxErrorMessageLength: 200,

  /** Events/errors held while the lazy client import is pending; anything beyond this is dropped. */
  maxPendingEvents: 50,
} as const;

/**
 * Per-environment RUM settings (environment.rum).
 *
 * Browser authorisation: the app monitor has a resource-based policy allowing
 * `rum:PutRumEvents` when the client sends `alias` (the environment name). Requests are unsigned.
 * The Cognito identity-pool (signed) mode is deliberately not supported: it would need
 * cognito-identity and sts in the CSP connect-src, and nothing in the estate uses it.
 */
export interface RumEnvironmentConfig {
  appMonitorId: string;
  region: string;
  alias: string;
  applicationVersion?: string;
  sessionSampleRate?: number;
}

/** Minimal surface of the aws-rum-web client we depend on. */
export interface RumClient {
  recordPageView(pageId: string): void;
  recordEvent(type: string, data: object): void;
  recordError(error: unknown): void;
  allowCookies(allow: boolean): void;
  enable(): void;
  disable(): void;
}

export type RumClientFactory = (config: RumEnvironmentConfig) => Promise<RumClient>;
